import { render, staticRenderFns } from "./BtnJustificativasReprovacao.vue?vue&type=template&id=0dc587a9"
import script from "./BtnJustificativasReprovacao.vue?vue&type=script&lang=js"
export * from "./BtnJustificativasReprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports